<template>
	<div>
		<label v-if="!is_homework">
			<span class="l_title">Количество примеров:</span>
			<div class="plm">
				<div class="plm__button plm__button--minus" @click="addSteps('-')"></div>
				<input type="number" min="1" max="999" :readonly="role == 'teacher' ? false : true" v-model="params.steps">
				<div class="plm__button plm__button--plus" @click="addSteps('+')"></div>
			</div>
		</label>
		<label v-show="!autoSettings">
			<span class="l_title">Формула: </span>
			<Select2 v-model="params.formula" :options="select_formulas" :settings="s2_settings" @change="emptyVals" />
		</label>

		<div class="formulas" v-if="params.formula == 0 && params.rank == '1/9'" v-show="!autoSettings">
			<span class="l_title">Ограничение по цифрам:</span>
			<div class="mini_cifers">
				<label v-for="cif in [4,5,6,7,8,9]" class="mini_cifers" :class="cif < params.direct_to ? 'active' : ''">
					<input type="radio" :value="cif" v-model="params.direct_to">
					<span></span>
					<p>{{ cif }}</p>
				</label>
			</div>
		</div>
		<div class="formulas" v-if="checkEmptyCifers">
			<div v-if="current_formula.cifers_dop_minus">
				<div class="razd"></div>
				<span class="l_title">Формулы 5-ки:</span>
				<div class="mini_cifers">
					<label v-for="cif in current_formula.cifers_dop_plus" class="mini_cifers">
						<input type="checkbox" :value="cif" v-model="params.cifers_dop">
						<span></span>
						<p>{{ cif }}</p>
					</label>
					<div class="mini_cifers__check" @click="clickCheck($event,'cifers_dop_plus', 'dop')"></div>
				</div>
				<div class="mini_cifers">
					<label v-for="cif in current_formula.cifers_dop_minus" class="mini_cifers">
						<input type="checkbox" :value="cif" v-model="params.cifers_dop">
						<span></span>
						<p>{{ cif }}</p>
					</label>
					<div class="mini_cifers__check" @click="clickCheck($event,'cifers_dop_minus', 'dop')"></div>
				</div>
			</div>
			<span class="l_title" v-if="current_formula.cifers_dop_minus">Формулы 10-ки:</span>
			<span class="l_title" v-else-if="params.formula == '15'">Формулы</span>
			<span class="l_title" v-else>Формулы {{ current_formula.cifers_plus.length > 5 ? '10' : '5'}}-ки:</span>
			<div class="mini_cifers" :class="current_formula.cifers_plus.length > 5 ? 'mini_cifers--wide' : ''">
				<label v-for="cif in current_formula.cifers_plus" class="mini_cifers">
					<input type="checkbox" :value="cif" v-model="params.cifers">
					<span></span>
					<p>{{ cif }}</p>
				</label>
				<div class="mini_cifers__check" @click="clickCheck($event,'cifers_plus', 'main')"></div>
			</div>
			<div class="mini_cifers" :class="current_formula.cifers_minus.length > 5 ? 'mini_cifers--wide' : ''">
				<label v-for="cif in current_formula.cifers_minus" class="mini_cifers">
					<input type="checkbox" :value="cif" v-model="params.cifers">
					<span></span>
					<p>{{ cif }}</p>
				</label>
				<div class="mini_cifers__check" @click="clickCheck($event, 'cifers_minus', 'main')"></div>
			</div>
		</div>
		<div class="razd"></div>
		<label>
			<span class="l_title">Количество слагаемых: </span>
			<div class="plm">
				<div class="plm__button plm__button--minus" @click="addTerms('-')"></div>
				<input type="number" min="3" max="999999" :readonly="role == 'teacher' ? false : true" v-model="params.terms">
				<div class="plm__button plm__button--plus" @click="addTerms('+')"></div>
			</div>
		</label>
		<div class="razd"></div>
		<label v-show="!autoSettings">
			<span class="l_title">Размер слагаемого: </span>
			<select2 v-model="params.rank" :options="rank_values" :settings="s2_settings"></select2>
		</label>
		<div class="razd"></div>
		<label>
			<span class="l_title">Скорость (секунд):</span>
			<div class="plm">
				<div class="plm__button plm__button--minus" @click="addSpeed('-')"></div>
				<input type="number" min="0.1" max="3" :readonly="role == 'teacher' ? false : true" v-model="params.speed">
				<div class="plm__button plm__button--plus" @click="addSpeed('+')"></div>
			</div>
		</label>

		<div class="razd"></div>
		<label class="check_label" v-show="!autoSettings">
			<input type="checkbox" class="uk-checkbox" v-model="params.show_reactions">
			<span>Анимации</span>
		</label>
		<div class="speechblock" v-show="!autoSettings">
			<div class="razd"></div>
			<label class="check_label">
				<input type="radio" class="uk-radio" value="" v-model="params.sounds">
				<span>Без звука</span>
			</label>
			<label class="check_label">
				<input type="radio" class="uk-radio" value="sound" v-model="params.sounds">
				<span>Звуки</span>
			</label>
			<label class="check_label">
				<input type="radio" class="uk-radio" value="speech" v-model="params.sounds">
				<span>Речь</span>
			</label>
		</div>

		<div class="modsettings__button" v-if="ingame">
			<button class="uk-button uk-button-primary" @click="apply">Применить</button>
		</div>
	</div>
</template>

<script>
  import Select2 from 'v-select2-component';
  import { mental_params_mix } from "../mental_params_mixin";
  import { mapState } from "vuex";

  export default {
    name: "settings",
    components: { Select2 },
    mixins: [
      mental_params_mix
    ],
    watch: {
      params: {
        handler: function (newValue) {
          if (!this.ingame) {
            this.$emit('params_changed', this.params);
          }
        },
        deep: true
      },
      'inparams': 'setParams',
      'params.sounds': 'checkSounds',
      'params.rank': 'checkSounds',
      'params.speed': 'checkSounds',

    },
    data() {
      return {
        params: ''
      }
    },
    props: {
      inparams: '',
      ingame: '',
      is_homework: '',
			autoSettings: ''
    },
    computed: {
      role() {
        return this.$store.state.user.role.code;
      },
    },
    methods: {
      setParams() {
        if (this.inparams) {
          console.log('Has props params');
          this.params = this.inparams;
        } else {
          console.log('No props params');
          this.params = this.$store.state.train.mental_params;
        }
        this.checkHomework();
      },

      apply() {
        this.$emit('params_changed', this.params);
        this.$parent.setShowsettings();
      },
      checkSpeed() {
        let speed = this.params.speed;
        let terms = this.params.terms;
        if (speed < 0.5 && terms <= 4) {
          this.params.terms = 4;
        }
      },
      checkSounds() {
        let sounds = this.params.sounds;
        let speed = this.params.speed * 1;
        let rank = this.params.rank.split('/')[1] * 1;

        //console.log('Sounds', sounds, speed, rank);
        let app = this;

        function setSound() {
          setTimeout(() => {
            app.params.sounds = 'sound';
          }, 200);
        }

        if (sounds === 'speech') {
          if (rank === 9 && speed < 1) {
            setSound();
          } else if (rank === 99 && speed < 1.4) {
            setSound();
          } else if (rank === 999 && speed < 1.9) {
            setSound();
          }
        }
      },
      checkHomework() {
        if (this.is_homework) {
          console.log('Это домашка!');
          //console.log(this.params.users);
          this.params.users = 1;
          this.params.steps = 1;
        }
      }
    },
    mounted() {
      //this.checkHomework();
      //console.log('mounted settings');
      let app = this;
      setTimeout(function () {
        app.setParams();
      }, 200);
    }
  }
</script>